import { render, staticRenderFns } from "./RecBox.vue?vue&type=template&id=1e6c9dd6&scoped=true&"
import script from "./RecBox.vue?vue&type=script&lang=js&"
export * from "./RecBox.vue?vue&type=script&lang=js&"
import style0 from "./RecBox.vue?vue&type=style&index=0&id=1e6c9dd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6c9dd6",
  null
  
)

export default component.exports